import {IProduct} from '@app/shared/models/product.model';
import {createAction, props} from '@ngrx/store';
import {EProductStatus} from '../enums/product.status.enum';

export enum NewOrderActions {
  LoadProduct = '[new-order component] new-oder page load product',
  LoadProductFromHeaderEffects = '[Header Effects] Header Effect load product',
  LoadProductSuccess = '[new-order effect] new-order load product success',
  LoadProductFailure = '[new-order effect] new-order load product Failure',
  LoadProductById = '[new-order component] new-oder page load product by id',
  LoadProductByIdSuccess = '[new-order effect] new-order load product by id success',
  LoadProductByIdFailure = '[new-order effect] new-order load product by id Failure',
  GetProduct = '[new-order component] select the product',
  ResetProducts = '[new-order component] new-oder page reset products',
}

export const loadProductById = createAction(
  NewOrderActions.LoadProductById,
  props<{productId: number; productStatus: EProductStatus}>()
);

export const LoadProductByIdSuccess = createAction(
  NewOrderActions.LoadProductByIdSuccess,
  props<{products: IProduct[]}>()
);

export const LoadProductByIdFailure = createAction(NewOrderActions.LoadProductByIdFailure, props<{reason: string}>());

export const loadProduct = createAction(NewOrderActions.LoadProduct, props<{productStatus: EProductStatus}>());

export const loadProductFromHeaderEffects = createAction(
  NewOrderActions.LoadProductFromHeaderEffects,
  props<{productStatus: EProductStatus}>()
);

export const loadProductSuccess = createAction(NewOrderActions.LoadProductSuccess, props<{products: IProduct[]}>());
export const loadProductFailure = createAction(NewOrderActions.LoadProductFailure, props<{reason: string}>());

export const getProduct = createAction(NewOrderActions.GetProduct, props<{product: IProduct}>());

export const resetProducts = createAction(NewOrderActions.ResetProducts);
